import React from 'react';
import { privacyPolicyData } from '../mock/mockData';
import PrivacyPolicyComponent from '../components/PrivacyPolicyComponent';

const PrivacyPolicy = () => {

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
            <PrivacyPolicyComponent
                title="Privacy Policy" 
                lastUpdated="10th December, 2025" 
                contentData={privacyPolicyData} 
            />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
